

























import { SPOTIFY_PLAYLIST_REGEX } from '@/constants'
import { combineArtistTitle } from '@/helpers/track'
import Axios from 'axios'
import { Component, Vue } from 'vue-property-decorator'

export interface IAudioFeatureTrack {
  title: string
  artist: string
  previewUrl: string
  album: string
  id: string
  url: string
  danceability: number
  energy: number
  key: string
  tempo: number
  valence: number
  _selected: boolean
}

@Component({
  components: {
    PlaylistSorterItem: require('./PlaylistSorterItem').default,
    GlobalWaveformPlayer: require('@/components/GlobalWaveformPlayer').default,
    SpotifyPlaylistSaveModal: require('@/components/SpotifyPlaylistSaveModal').default
  }
})
export default class PlaylistSorter extends Vue {
  playlistLink: string = ''
  loading: boolean = false

  results: IAudioFeatureTrack[] = []

  get selectedTrackIds(): string[] {
    return this.results.filter(x => x._selected).map(x => x.id)
  }

  get disabled(): boolean {
    return !this.playlistLink || !SPOTIFY_PLAYLIST_REGEX.test(this.playlistLink)
  }

  get waveformItems(): { url: string, name: string }[] {
    return this.results.map(x => {
      return {
        url: x.previewUrl,
        name: combineArtistTitle(x.artist, x.title)
      }
    })
  }

  toggleResultSelected(index: number) {
    this.$set(this.results[index], '_selected', !this.results[index]._selected)
  }

  openSpotifySaveModal() {
    (this.$refs.spotifySaveModal as any).open()
  }

  selectAll() {
    for (const r of this.results) {
      this.$set(r, '_selected', true)
    }
  }

  async search() {
    this.loading = true

    try {
      const { data } = await Axios.get('/external/hidden-playlist-sorted', {
        params: {
          playlistLink: this.playlistLink
        }
      })

      this.results = data.tracks
    } catch (error) {
      console.error(error)
    }

    this.loading = false
  }
}
